import {useEffect, useState} from "react";
import {privateApi} from "../api";

type StatusInfo = {
    id: string;
    name: string;
    color: string;
};

type CallResponse = {
    statuses: StatusInfo[];
};

export function useOrderStatuses() {
    const [statuses, setStatuses] = useState<StatusInfo[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        privateApi
            .get<CallResponse>("/cr-order-manager/v1/status")
            .then((res) => {
                if (isMounted) {
                    setStatuses(res.data.statuses ?? []);
                }
            })
            .finally(() => {
                if (isMounted) setLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, []);

    return {statuses, loading};
}